import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../../constants/index";
import { useNavigate } from 'react-router-dom';
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import moment from "moment";
import PrintEmailComponent from "./Component/PrintEmailComponent";
import PaySlipComponent from "../../../../components/PaySlipComponent";
import ReactDOM from "react-dom/client";
import printJS from "print-js";
import { toast } from "react-toastify";
import UAEPaySlipComponent from "../../../../components/UAEPaySlipComponent";

const PrintEmailPaySlip = () => {
  const navigate = useNavigate();
  const intialFilterData = [
    {
      label: "Email",
      value: { value: 0, label: "Official" },
    },
    { label: "Branch", value: { value: 2, label: "NSS-Main" } },
  ];
  const [searchTerm, setSearchTerm] = useState("");
  const [printPaySlipData, setPrintPaySlipData] = useState([]);
  const [filterFormData, setFilterData] = useState(intialFilterData);
  console.log("filterFormData", filterFormData);

  const [departmentlist, setDepartmentlist] = useState([]);
  const [designationOptList, setDesignationOptList] = useState([]);
  const [monthOptList, setMonthOptList] = useState([]);
  const [employeeList, setEmployeeList] = useState([]);
  const [branchOptList, setBranchOptList] = useState([]);
  const [showPayslipModal, setShowPayslipModal] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(true);

  const [emailOption, setEmailOption] = useState([]);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Print/Email PaySlip"));
  }, []);
  const columns = [
    // { key: "Employee", label: "Employee", align: "center", visible: true },
    // { key: "Email", label: "Email", align: "center", visible: true },
    // { key: "PresentDays", label: "Present Days", align: "center", visible: true },
  ];
  useEffect(() => {
    fetchPayrollMaster();
  }, []);
  const handleChange = (e, name) => {
    setFilterData((prevFormData) => {
      // Check if the label already exists
      const existingLabelIndex = prevFormData.findIndex(
        (item) => item.label === name
      );

      // If the label exists, update its value
      if (existingLabelIndex !== -1) {
        return prevFormData.map((item, index) =>
          index === existingLabelIndex
            ? { ...item, value: e } // Store the whole selected object { value, label }
            : item
        );
      } else {
        // If the label doesn't exist, add a new label-value pair
        return [...prevFormData, { label: name, value: e }];
      }
    });
  };

  const formDatas = [
    { name: "Branch", type: "Select", options: [...branchOptList] },
    { name: "Month", type: "Select", options: [...monthOptList] },
    { name: "Employee", type: "Select", options: [...employeeList] },
    { name: "Department", type: "Select", options: [...departmentlist] },
    { name: "Designation", type: "Select", options: [...designationOptList] },
    { name: "Email", type: "Select", options: [...emailOption] },
    // { name: "Tax Regime", type: "Select", options: [...taxRegimelistset] },
  ];

  const fetchPayrollMaster = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}rujul/payslips-data`);
      if (response.status === 200) {
        // Department List
        const depList = response?.data?.data?.department?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setDepartmentlist(depList);

        // Designation List
        const designationlist = response?.data?.data?.designation?.map(
          (tech) => ({
            value: tech.value,
            label: tech.text,
          })
        );
        setDesignationOptList(designationlist);
        // Month List
        const monthlist = response?.data?.data?.months?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setMonthOptList(monthlist);
        // Employee List
        const emplist = response?.data?.data?.employee?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmployeeList(emplist);
        // Branch List
        const emaillist = response?.data?.data?.email?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setEmailOption(emaillist);
        const branchlist = response?.data?.data?.branch?.map((tech) => ({
          value: tech.value,
          label: tech.text,
        }));
        setBranchOptList(branchlist);
      } else {
        console.error(
          "Failed to fetch Expense Advance. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Expense Advance", error);
    }
  };


  const [apiStatus, setApiStatus] = useState('')
  const handleGetData = async () => {
    console.log("API call initiated");

    // Reset API status
    setApiStatus(undefined);

    try {
      // Validate required fields first
      const monthFilter = filterFormData.find((o) => o.label === "Month");
      if (!monthFilter?.value?.value) {
        toast.error("Month field is required");
        setApiStatus("")
        return;
      }

      // Extract all filter values at once for better readability
      const filters = {
        monthID: String(monthFilter.value.value).trim(),
        branchID: filterFormData.find((o) => o.label === "Branch")?.value?.value || 0,
        departmentID: filterFormData.find((o) => o.label === "Department")?.value?.value || "",
        designationID: filterFormData.find((o) => o.label === "Designation")?.value?.value || "",
        employeeID: filterFormData.find((o) => o.label === "Employee")?.value?.value || 0
      };

      // Validate monthID again (defensive programming)
      if (!filters.monthID || isNaN(filters.monthID)) {
        toast.error("Invalid Month selected");
        return;
      }

      // Construct query parameters more safely
      const queryParams = new URLSearchParams({
        p_MonthID: filters.monthID,
        p_BranchID: filters.branchID,
        p_DepartmentID: filters.departmentID,
        p_DesignationID: filters.designationID,
        p_EmployeeID: filters.employeeID
      });

      // Make API call
      const response = await GetServiceCaller(
        `${API_URL}rujul/payslip-report-data?${queryParams.toString()}`
      );

      // Handle response
      if (response?.status === 200) {
        setApiStatus(response.status);
        const responseData = response?.data?.data || [];

        if (responseData.length === 0) {
          toast.info("No data found for the selected filters", {
            position: "top-right",
            style: {
              marginTop: "20px",  // Adjust this value based on your navbar height
              zIndex: 9999       // Ensure it appears above other elements
            }
          });
        }

        setPrintPaySlipData(responseData);
      } else {
        throw new Error(`API returned status: ${response?.status}`);
      }
    } catch (error) {
      console.error("Error in handleGetData:", error);
      setApiStatus(500); // Set error status
      toast.error("Failed to fetch data. Please try again.");
    } finally {
      // Any cleanup can go here
    }
  };

  const [formattedKeys, setFormattedKeys] = useState([]);
  console.log('formattedKeys',);

  const [totals, setTotals] = useState({});
  useEffect(() => {
    if (printPaySlipData.length > 0) {
      // Define columns to exclude
      const excludedColumns = [
        'BranchID',
        'CompanyID',
        'ContactID',
        'ID',
        'MonthID',
        'RevisionNumber',
        'tmpIsAllowed',
        'MonthName',
        // Add any other columns you want to exclude
      ];

      // Define priority columns (these will appear first)
      const priorityColumns = [
        { originalKey: 'Employee', label: 'Employee' },
        { originalKey: 'Email', label: 'Email' }
      ];

      const extractedKeys = [];

      // Add priority columns first if they exist in the data
      priorityColumns.forEach(priorityCol => {
        if (printPaySlipData[0].hasOwnProperty(priorityCol.originalKey)) {
          extractedKeys.push({
            key: priorityCol.originalKey,
            label: priorityCol.label
          });
        }
      });

      // Process remaining columns
      Object.keys(printPaySlipData[0]).forEach((key) => {
        // Skip if column is excluded or already added as priority
        if (
          excludedColumns.includes(key) ||
          priorityColumns.some(pc => pc.originalKey === key)
        ) {
          return;
        }

        // Format the key name
        const newLabel = key
          .replace(/[\$\d]/g, "")
          .replace(/_/g, " ")
          .trim();

        extractedKeys.push({
          key: key,
          label: newLabel
        });
      });

      setFormattedKeys(extractedKeys);
    }
  }, [printPaySlipData]);

  useEffect(() => {
    if (printPaySlipData.length > 0) {
      const sums = {};

      formattedKeys.forEach(({ key }) => {
        sums[key] = printPaySlipData.reduce(
          (acc, item) => acc + (Number(item[key]) || 0),
          0
        );
      });

      setTotals(sums);
    }
  }, [printPaySlipData, formattedKeys]);

  const dataSets = { "Pay Slab Line": printPaySlipData };

  const columnHeadersMap = {
    "Pay Slab Line": [...columns, ...formattedKeys],
  };


  const [newSelectedStatus, setNewSelectedStatus] = useState("");
  const [selectedItem, setSelectedItem] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedItems, setSelectedItems] = useState({});
  const [selectedResources, setSelectedResources] = useState([]);
  const [shiftID, setShiftID] = useState("");

  const handleColumnSelect = (selectedOption, item, columnName) => {
    setPrintPaySlipData((prevData) =>
      prevData.map((row) =>
        row.ContactID === item.ContactID
          ? { ...row, [columnName]: Number(selectedOption.value).toFixed(4) }
          : row
      )
    );

    setSelectedItem(item);
    setNewSelectedStatus(Number(selectedOption.value).toFixed(4));

    setSelectedResources((prevResources) =>
      prevResources.map((resource) =>
        resource.ContactID === item.ContactID
          ? {
            ...resource,
            [columnName]: Number(selectedOption.value).toFixed(4),
          }
          : resource
      )
    );
  };

  const handleSelectAllChange = (event) => {
    const checked = event.target.checked;
    setSelectAllChecked(checked);
    const newSelectedItems = {};
    const newSelectedResources = checked ? [...printPaySlipData] : [];

    if (checked) {
      printPaySlipData.forEach((item) => {
        newSelectedItems[item.ContactID] = true;
      });
    }

    setSelectedItems(newSelectedItems);
    setSelectedResources(newSelectedResources);
  };

  const handleCheckboxChange = (e, id, item) => {
    const isChecked = e.target.checked;
    setSelectedItems((prevSelectedItems) => {
      const updatedSelectedItems = {
        ...prevSelectedItems,
        [id]: isChecked,
      };

      const allSelected =
        Object.keys(updatedSelectedItems).length === printPaySlipData.length &&
        Object.values(updatedSelectedItems).every(Boolean);
      setSelectAllChecked(allSelected);

      return updatedSelectedItems;
    });

    setSelectedResources((prevSelectedResources) => {
      if (isChecked) {
        return [...prevSelectedResources, item];
      } else {
        return prevSelectedResources.filter(
          (resource) => resource.ContactID !== item.ContactID
        );
      }
    });
  };

  const checkBoxRequiredMap = {
    "Pay Slab Line": true, // Checkbox required
  };

  const handleGetAllMail = async () => { };

  // const handlePrint = async (row) => {
  //   try {
  //     const monthFilter = filterFormData.find((o) => o.label === "Month");
  //     const monthID = monthFilter ? monthFilter.value.value : null;

  //     if (!monthID) {
  //       console.error("MonthID is missing");
  //       return; 
  //     }

  //     const response = await GetServiceCaller(
  //       `${API_URL}rujul/show-payslip?MonthID=${monthID}&EmployeeID=${row?.ContactID}&ID=${row.ID}`
  //     );

  //     if (response?.status === 200) {
  //       const result = response?.data?.data || [];

  //       setShiftID(response?.data?.employeeDetails?.[0]?.ShiftId);
  //       const printContainer = document.createElement("div");
  //       printContainer.id = "printSection";
  //       document.body.appendChild(printContainer);

  //       const root = ReactDOM.createRoot(printContainer);
  //       root.render(
  //         shiftID !== 6 ? (
  //           <PaySlipComponent
  //             result={result}
  //             response={response}
  //             componentRef={componentRef}
  //           />
  //         ) : (
  //           <UAEPaySlipComponent
  //             result={result}
  //             response={response}
  //             componentRef={componentRef}
  //           />
  //         )
  //       );

  //       setTimeout(() => {
  //         printJS({
  //           printable: "printSection",
  //           type: "html",
  //           css: ["index.css"],
  //           style: `
  //               @page { size: A4; margin: 0.7mm; }
  //               body { font-family: Arial, sans-serif; padding: 20px; background: white !important; color: black !important; }
  //               table { border-collapse: collapse; width: 100%; }
  //               th, td { border: 1px solid black; padding: 8px; text-align: left; }
  //               .btn, .remark-container { display: none !important; }
  //             `,
  //           scanStyles: false,
  //         });

  //         setTimeout(() => {
  //           document.body.removeChild(printContainer);
  //         }, 1000);
  //       }, 500);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching payslip data:", error);
  //   }
  // };
  const componentRef = useRef(null);
  const handlePayslipModel = (item) => {
    console.log('item ID', item.ID);
    console.log('ContactID', item.ContactID);
    console.log('MonthID', item.MonthID);

    // Create URL and state as query parameters
    const url = `/rujul/hrm/print-email-payslip/payment-slip/${item.ContactID}`;
    const queryParams = new URLSearchParams({
      ID: item.ID,
      ContactID: item.ContactID,
      MonthID: item.MonthID,
    }).toString();

    // Open in new tab
    window.open(`${url}?${queryParams}`, '_blank');
  };


  const closeModal = () => {
    setShowPayslipModal(false); // Close the modal
  };




  const handleReset = async() => {
    setFilterData(intialFilterData)
    // Reset API status
    setApiStatus(undefined);

    try {

      // Extract all filter values at once for better readability
      const filters = {
        monthID: 0,
        branchID: 2,
        departmentID: "",
        designationID: "",
        employeeID: 0
      };

  

      // Construct query parameters more safely
      const queryParams = new URLSearchParams({
        p_MonthID: filters.monthID,
        p_BranchID: filters.branchID,
        p_DepartmentID: filters.departmentID,
        p_DesignationID: filters.designationID,
        p_EmployeeID: filters.employeeID
      });

      // Make API call
      const response = await GetServiceCaller(
        `${API_URL}rujul/payslip-report-data?${queryParams.toString()}`
      );

      // Handle response
      if (response?.status === 200) {
        setApiStatus(response.status);
        const responseData = response?.data?.data || [];

        if (responseData.length === 0) {
          toast.info("No data found for the selected filters", {
            position: "top-right",
            style: {
              marginTop: "20px",  // Adjust this value based on your navbar height
              zIndex: 9999       // Ensure it appears above other elements
            }
          });
        }

        setPrintPaySlipData(responseData);
      } else {
        throw new Error(`API returned status: ${response?.status}`);
      }
    } catch (error) {
      console.error("Error in handleGetData:", error);
      setApiStatus(500); // Set error status
      toast.error("Failed to fetch data. Please try again.");
    } finally {
      // Any cleanup can go here
    }
  }
  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className=" rounded bg-white" id="skill-table-area">
          <div className="row">
            <PrintEmailComponent
              dataSets={dataSets}
              columnHeadersMap={columnHeadersMap}
              columns={columns}
              itemsPerPage={10}
              isApiStatus={apiStatus}
              isSorting={true}
              isFilterRequired={true}
              searchTerm={searchTerm}
              isCheckBoxRequired={true}
              isActionRequired={true}
              formattedKeys={formattedKeys}
              totals={totals}
              handleSubmitButton={handleGetAllMail}
              handleColumnSelect={handleColumnSelect}
              selectedResource={selectedResources}
              selectAllChecked={selectAllChecked}
              handleCheckboxChange={handleCheckboxChange}
              handleSelectAllChange={handleSelectAllChange}
              formDatas={formDatas}
              setSearchTerm={setSearchTerm}
              handleReset={handleReset}
              filterFormData={filterFormData}
              handleGetData={handleGetData}
              checkBoxRequiredMap={checkBoxRequiredMap}
              handleChange={handleChange}
              showIcon1={true}
              handleIcon1={handlePayslipModel}
              icons={{
                Icon1: <i class="bi bi-printer-fill"></i>,
                Icon1Text: " Print",
              }}
            />
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <h2>Payslip Details</h2>
            {/* <p>{JSON.stringify(item)}</p> */}
            <button onClick={closeModal}>Close</button>
          </div>
        </div>
      )}
    </>
  );
};

export default PrintEmailPaySlip;
